/**
 * The API sends local times as "YYYY-MM-DD HH:mm:ss" (some endpoints as ISO "YYYY-MM-DDTHH:mm:ss...").
 * The Date is built from the numbers instead of `new Date(string)`: non-ISO strings such as
 * "2026/10/14 02:43:55" depend on each browser's legacy parser, and some devices turn them into an
 * Invalid Date, which makes `$d()` throw "RangeError: Invalid time value" and breaks the whole page.
 *
 * Returns a Date in the browser's local time zone (any "Z"/offset suffix is ignored on purpose, the value
 * is already a local time), or null when the value can not be read.
 */
export function parseGameTime (time) {
  if (!time) {
    return null
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(String(time))

  if (!match) {
    return null
  }

  // A missing part (date without time, time without seconds) counts as 0
  const [year, month, day, hours, minutes, seconds] = match.slice(1).map(part => Number(part ?? 0))
  const date = new Date(year, month - 1, day, hours, minutes, seconds)

  return Number.isNaN(date.getTime()) ? null : date
}

/**
 * Formats a game time with the vue-i18n date format `format` (e.g. 'time', 'dateLong').
 * Returns '' for a missing or unreadable time instead of throwing.
 */
export function formatGameTime (vm, time, format) {
  const date = parseGameTime(time)

  return date ? vm.$d(date, format) : ''
}
